import React from 'react';
import proptypes from 'prop-types';
import { Duplicate } from '@one-thd/sui-icons';

const { bool, func, string } = proptypes;

/**
 * Reusable button component for Copy To actions in the action bar
 * Handles both sticky and regular bar variants with proper styling
 */
export const CopyToButton = ({
  onClick,
  disabled,
  className,
  ariaLabel,
  showIcon
}) => {
  return (
    <div className="sui-w-full">
      <button
        aria-label={ariaLabel}
        type="button"
        disabled={disabled}
        onClick={onClick}
        className={className}
      >
        {showIcon && <Duplicate size="small" />}
        Copy to
      </button>
    </div>
  );
};

CopyToButton.propTypes = {
  onClick: func.isRequired,
  disabled: bool,
  className: string,
  ariaLabel: string,
  showIcon: bool
};

CopyToButton.defaultProps = {
  disabled: false,
  className: '',
  ariaLabel: 'Copy to',
  showIcon: true
};
